import React, { useState, useEffect } from 'react';
import "../../styles/sidebar/BotNetworks.css";

const API = 'https://api.anti-bot.ai';

const THREAT_CONFIG = {
  CRITICAL: { label: 'קריטי',  color: '#ff2d55' },
  HIGH:     { label: 'גבוה',   color: '#ff6b00' },
  MEDIUM:   { label: 'בינוני', color: '#ffd60a' },
  LOW:      { label: 'נמוך',   color: '#30d158' },
};

const COUNTRY_INFO = {
  GB: 'בריטניה', US: 'ארה״ב',   RU: 'רוסיה',    CN: 'סין',
  IR: 'איראן',   DE: 'גרמניה',  FR: 'צרפת',     IL: 'ישראל',
  TR: 'טורקיה',  BY: 'בלארוס',  UA: 'אוקראינה', JP: 'יפן',
  SA: 'סעודיה',  SG: 'סינגפור', BR: 'ברזיל',    RO: 'רומניה',
  CA: 'קנדה',    FI: 'פינלנד',  ES: 'ספרד',     IT: 'איטליה',
  AU: 'אוסטרליה',YE: 'תימן',    ID: 'אינדונזיה', DK: 'דנמרק',
};

const POLITICIANS = [
  { username: 'netanyahu',      name: 'בנימין נתניהו' },
  { username: 'bezalelsm',      name: 'בצלאל סמוטריץ\'' },
  { username: 'YoavKisch',      name: 'יואב קיש' },
  { username: 'itamarbengvir',  name: 'איתמר בן גביר' },
  { username: 'gantzbe',        name: 'בני גנץ' },
  { username: 'TallyGotliv',    name: 'טלי גוטליב' },
];

function formatTime(isoStr) {
  const d = new Date(isoStr);
  const day   = d.getDate().toString().padStart(2,'0');
  const month = (d.getMonth()+1).toString().padStart(2,'0');
  const hour  = d.getHours().toString().padStart(2,'0');
  return `${day}/${month} · ${hour}:00`;
}

function NetworkCard({ net, politicianName, index }) {
  const cfg = THREAT_CONFIG[net.threat] || THREAT_CONFIG.LOW;
  const time = formatTime(net.hour);
  const code = net.countries[0]?.code;
  const countryName = code ? (COUNTRY_INFO[code] || code) : 'מוסתר / VPN';

  return (
    <div className="bn-card" style={{ '--accent': cfg.color, animationDelay: `${index * 0.05}s` }}>
      <div className="bn-card-stripe" style={{ background: cfg.color }} />

      <div className="bn-card-top">
        <div className="bn-country">
          {code ? (
            <img
              src={`https://flagcdn.com/32x24/${code.toLowerCase()}.png`}
              alt={code}
              className="bn-flag"
            />
          ) : (
            <span className="bn-flag-unknown">🕵️</span>
          )}
          <span className="bn-country-name">{countryName}</span>
        </div>
        <span className="bn-threat-badge" style={{ color: cfg.color, borderColor: cfg.color + '44', background: cfg.color + '11' }}>
          {cfg.label}
        </span>
      </div>

      <div className="bn-bots-line">
        <span className="bn-bots-count">{net.total_bots}</span>
        <span className="bn-bots-desc">בוטים תקפו את {politicianName}</span>
      </div>

      <div className="bn-time">{time}</div>
    </div>
  );
}

export default function BotNetworks() {
  const [selected, setSelected]     = useState('netanyahu');
  const [networks, setNetworks]     = useState([]);
  const [loading, setLoading]       = useState(false);
  const [filter, setFilter]         = useState('ALL');
  const [lastUpdate, setLastUpdate] = useState(null);

  const politician = POLITICIANS.find(p => p.username === selected);

  useEffect(() => {
    const load = () => {
      fetch(`${API}/api/bot-networks/${selected}?t=${Date.now()}`)
        .then(r => r.json())
        .then(d => {
          if (d.success) {
            setNetworks(d.networks);
            setLastUpdate(d.last_analyzed
              ? new Date(d.last_analyzed).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
              : null);
          }
        })
        .catch(console.error)
        .finally(() => setLoading(false));
    };

    setLoading(true);
    load();
    const interval = setInterval(load, 30_000);
    return () => clearInterval(interval);
  }, [selected]);

  const filtered = networks.filter(n =>
    filter === 'ALL' || n.threat === filter
  );

  const totalBots = filtered.reduce((s, n) => s + n.total_bots, 0);

  const counts = { ALL: networks.length };
  ['CRITICAL','HIGH','MEDIUM','LOW'].forEach(t => {
    counts[t] = networks.filter(n => n.threat === t).length;
  });

  return (
    <div className="bn-root" dir="rtl">

      <div className="bn-header">
        <h1 className="bn-title">רשתות בוטים</h1>
        <p className="bn-subtitle">{counts['ALL']} רשתות · {totalBots.toLocaleString()} בוטים</p>
        {lastUpdate && <p className="bn-subtitle">עודכן: {lastUpdate}</p>}
      </div>

      <div className="bn-politicians">
        {POLITICIANS.map(p => (
          <button
            key={p.username}
            className={`bn-pol-btn ${selected === p.username ? 'active' : ''}`}
            onClick={() => setSelected(p.username)}
          >
            {p.name}
          </button>
        ))}
      </div>

      <div className="bn-filters">
        {['ALL','CRITICAL','HIGH','MEDIUM','LOW'].map(t => (
          <button
            key={t}
            className={`bn-filter-btn ${filter === t ? 'active' : ''}`}
            style={filter === t && t !== 'ALL' ? { borderColor: THREAT_CONFIG[t]?.color, color: THREAT_CONFIG[t]?.color } : {}}
            onClick={() => setFilter(t)}
          >
            {t === 'ALL' ? 'הכל' : THREAT_CONFIG[t].label}
            <span className="bn-filter-count">{counts[t] || 0}</span>
          </button>
        ))}
      </div>

      {loading ? (
        <div className="bn-loading"><div className="bn-spinner" /><span>טוען...</span></div>
      ) : (
        <div className="bn-grid">
          {filtered.map((net, i) => (
            <NetworkCard key={net.hour} net={net} politicianName={politician?.name || selected} index={i} />
          ))}
          {filtered.length === 0 && <div className="bn-empty">לא נמצאו רשתות</div>}
        </div>
      )}
    </div>
  );
}